module.exports = __webpack_public_path__ + "static/img/banner.d38996c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner.png
// module id = 5
// module chunks = 0